<script>
export default {
    name: 'ExtensionKeepaError',
    props: {
        message: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            alwaysUseKeepa: false,
        }
    },
    methods: {
        handleHideModal() {
            const modal = document.querySelector('.keepa-error-modal')
            if (modal) {
                modal.classList.remove('show')
                modal.style.display = 'none'
            }
        },
    },
}
</script>

<!-- eslint-disable max-len -->

<template>
    <div class="modal fade keepa-error-modal" tabindex="-1" role="dialog" aria-labelledby="keepa-error-modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mx-auto" role="document" style="width: 330px">
            <div class="modal-content shadow-lg">
                <!-- Header -->
                <div class="modal-top-cover bg-dark text-center">
                    <figure class="position-absolute end-0 start-0" style="bottom: -5px">
                        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
                            <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
                        </svg>
                    </figure>

                    <div class="modal-close">
                        <button type="button" @click="handleHideModal" class="btn-close btn-close-light" aria-label="Close"></button>
                    </div>
                </div>
                <!-- End Header -->
                <div class="modal-top-cover-icon">
                    <span class="icon icon-light icon-circle icon-centered shadow-sm">
                        <img src="@/assets/svg/icon.svg" height="30" />
                    </span>
                </div>

                <div class="modal-body">
                    <p style="hyphens: auto" v-html="message === 'no_token' ? $t('views.extension.alertKeepaErrorNoToken') : $t('views.extension.alertKeepaError')"></p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-white p-1" @click="handleHideModal">{{ $t('actions.ok') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.keepa-error-modal {
    .modal-top-cover {
        min-height: 4rem;
    }

    .modal-body {
        padding: 0 1rem;
    }

    .modal-footer {
        padding: 0.5rem;

        button {
            font-size: 11px;
        }
    }
    .btn-close {
        width: 0.5rem;
        height: 0.5rem;
    }
}
</style>
